import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateGroup } from "../services/group.services";
import { GROUPS_QUERY_KEYS } from "../queryKeys";
import { GroupFormData } from "../types/group.types";

type UpdateGroupVariables = {
  entityId: number;
  groupId: number;
  data: GroupFormData;
};

export const useUpdateGroupMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ entityId, groupId, data }: UpdateGroupVariables) => updateGroup(entityId, groupId, data),
    onSuccess: (_, { entityId, groupId }) => {
      queryClient.invalidateQueries({
        queryKey: GROUPS_QUERY_KEYS.groupsList(entityId),
      });
      queryClient.invalidateQueries({
        queryKey: GROUPS_QUERY_KEYS.groupDetails(groupId),
      });
    },
  });
};
